import { removeEmpty } from "../array/removeEmpty";
import Cookies from "js-cookie";

type BasketItem = {
  itemPrice: string;
  productId: string;
  qty: string;
  services: [];
  sku: string;
};

type Basket = {
  subTotal: string;
  product: BasketItem[];
};

export function getBasket(): Basket {
  const basketCookie = Cookies.get("cached_basket");

  if (!basketCookie) {
    return {
      subTotal: "0.00",
      product: [],
    };
  }

  const cookieSegments = basketCookie.split("^");

  return {
    subTotal: getSubTotal(cookieSegments),
    product: getBasketItems(cookieSegments),
  };
}

function getSubTotal(basketCookieSegments: string[]): string {
  const subTotalSegment = basketCookieSegments[basketCookieSegments.length - 2];

  const subTotal = subTotalSegment?.match(/\d+.\d+/)?.[0];
  if (!subTotal) {
    throw new Error("Basket cookie did not contain valid subtotal");
  }
  return subTotal;
}

function getBasketItems(basketCookieSegments: string[]): BasketItem[] {
  const itemSegments = basketCookieSegments.slice(0, -2);
  return removeEmpty(itemSegments.map(getBasketItem));
}

function getBasketItem(item: string): BasketItem | undefined {
  const data = item.split("|");

  const productId = data[1];
  const sku = data[3];
  const itemPrice = data[4];
  const qty = data[5];

  if (!productId || !sku || !itemPrice || !qty) return undefined;

  return {
    productId,
    sku,
    itemPrice,
    qty,
    services: [],
  };
}
